export class ConfirmPasswordRequest {
    userID: number;
    confirmPassword: string;
     userName: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/requests/confirm-password-request.model.ts